import Vue from 'vue';
import Vuex from 'vuex';

import monthlyApply from './monthly-apply';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		selectCargo: 'CORPORATION',
		name: '',
    mobile: '',
    states: '',
    city: '',
		privacy: '',
		third: '',
		fileList: [],
  },
  getters: {},
	mutations: {
		setData(state, { selectCargo, name, mobile, states, city, privacy, third, fileList}) {
      state.selectCargo = selectCargo;
      state.name = name;
      state.mobile = mobile;
      state.states = states;
      state.city = city;
      state.privacy = privacy;
      state.third = third;
      state.fileList = fileList.map(v => ({
        file: v.file, //new File([v.file], v.name, { type: v.file.type }),
        name: v.name
      }));
		}
	},
	actions: {},
  modules: {
    monthly: {
      namespaced: true,
      ...monthlyApply
    }
  }
});
